var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wheel-home-bet-content-new select-color" }, [
    _c("div", { staticClass: "select-color__label" }, [_vm._v("倍率")]),
    _c("div", { staticClass: "select-color__colors" }, [
      _c(
        "div",
        {
          staticClass: "select-color__color select-color__color_x2",
          class: { "is-active": _vm.activeColor === _vm.Multiplier.X2 },
          on: {
            click: function ($event) {
              return _vm.setColor(_vm.Multiplier.X2)
            },
          },
        },
        [
          _c("div", { staticClass: "select-color__color-inner" }, [
            _c("span", [_vm._v(_vm._s(_vm.formatMultiplier("X2")))]),
            _c("i", { staticClass: "icon icon_new icon_check" }),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "select-color__color select-color__color_x3",
          class: { "is-active": _vm.activeColor === _vm.Multiplier.X3 },
          on: {
            click: function ($event) {
              return _vm.setColor(_vm.Multiplier.X3)
            },
          },
        },
        [
          _c("div", { staticClass: "select-color__color-inner" }, [
            _c("span", [_vm._v(_vm._s(_vm.formatMultiplier("X3")))]),
            _c("i", { staticClass: "icon icon_new icon_check" }),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "select-color__color select-color__color_x5",
          class: { "is-active": _vm.activeColor === _vm.Multiplier.X4 },
          on: {
            click: function ($event) {
              return _vm.setColor(_vm.Multiplier.X4)
            },
          },
        },
        [
          _c("div", { staticClass: "select-color__color-inner" }, [
            _c("span", [_vm._v(_vm._s(_vm.formatMultiplier("X4")))]),
            _c("i", { staticClass: "icon icon_new icon_check" }),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "select-color__color select-color__color_x20",
          class: { "is-active": _vm.activeColor === _vm.Multiplier.X35 },
          on: {
            click: function ($event) {
              return _vm.setColor(_vm.Multiplier.X35)
            },
          },
        },
        [
          _c("div", { staticClass: "select-color__color-inner" }, [
            _c("span", [_vm._v(_vm._s(_vm.formatMultiplier("X35")))]),
            _c("i", { staticClass: "icon icon_new icon_check" }),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }